import React from 'react';

const Toolbar = ({ children, actions, className = '' }) => (
  <div className={`toolbar ${className}`.trim()}>
    <div className="toolbar-fields">{children}</div>
    {actions && <div className="toolbar-actions">{actions}</div>}
  </div>
);

export default Toolbar;
